import {
  removeGlobalNotification,
  showGlobalNotification,
} from '@driftt/traffic-control'
import { pathOr } from 'ramda'
import { connect } from 'react-redux'

import BotEditorLayout from 'layouts/BotEditorLayout'
import { setPreviewState } from 'modules/editor/actions'
import { BOT_FLOW_MODES } from 'modules/editor/reducer'
import {
  receiveLandingPageCname,
  receiveLandingPageIntegrations,
  receiveLandingPages,
  receiveLandingPageSubdomain,
} from 'modules/landingpages/actions'

const mapStateToProps = (state) => ({
  currentUser: state.user,
  isPreviewState: state.__PLAYBOOK_EDITOR.editor.isPreviewState,
  isExperimentEnabled: state.__PLAYBOOK_EDITOR.playbook.experiment?.enabled,
  type: state.__PLAYBOOK_EDITOR.editor.type,
  orgUsers: state.org.users,
  orgProperties: state.org.properties,
  playbookErrors: state.__PLAYBOOK_EDITOR.playbookValidation,
  outdatedBlocks: pathOr([], ['__BOT_EDITOR_v2', 'outdatedBlocks'])(state),
  botFlowMode: pathOr(BOT_FLOW_MODES.BUILD, [
    '__PLAYBOOK_EDITOR',
    'editor',
    'botFlowMode',
  ])(state),
})

const mapDispatchToProps = (dispatch) => {
  return {
    showGlobalNotification: (config) => {
      dispatch(showGlobalNotification(config))
    },
    removeGlobalNotification: (index) => {
      dispatch(removeGlobalNotification(index))
    },
    onReceiveLandingPages: (settings) => {
      dispatch(receiveLandingPages(settings))
    },
    onReceiveLandingPageSubdomain: (domain) => {
      dispatch(receiveLandingPageSubdomain(domain))
    },
    onReceiveLandingPageIntegrations: (data) => {
      dispatch(receiveLandingPageIntegrations(data))
    },
    onReceiveLandingPageCname: (data) => {
      dispatch(receiveLandingPageCname(data))
    },
    onSetPreviewState: (isPreview) => {
      dispatch(setPreviewState(isPreview))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(BotEditorLayout)
